import MomentUtils from '@date-io/moment';
import { TextFieldProps } from '@material-ui/core';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Moment } from 'moment';
import React from 'react';

interface Props {
  value: Moment | null;
  onChange: (date: Moment | null) => void;
  InputProps?: TextFieldProps['InputProps'];
}

export function DateInput({ value, onChange, InputProps }: Props): React.ReactElement {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDateTimePicker
        variant="inline"
        format="YYYY/MM/DD HH:mm"
        margin="dense"
        label="Date"
        value={value}
        onChange={onChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        InputProps={InputProps}
      />
    </MuiPickersUtilsProvider>
  );
}
